<template src="./reporting.html"></template>

<script>

import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import FileSaver from 'file-saver'
import { EventBus } from '@/router/bus'
import { hasAdminClaim } from '@/router/auth.js'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      pageLoader: false,
      reports: [
        {
          title: this.$t('reports.projectListReportTitle'),
          description: this.$t('reports.projectListReportDescription'),
          type: 'project-list',
          codeName: 'PIMIS-001',
          reportFormats: ['pdf']
        },
        {
          title: this.$t('reports.projectSummaryReportTitle'),
          description: this.$t('reports.projectSummaryReportDescription'),
          type: 'project-summary',
          codeName: 'PIMIS-002',
          reportFormats: ['pdf']
        },
        {
          title: this.$t('reports.projectsRealizedReportTitle'),
          description: this.$t('reports.projectsRealizedReportDescription'),
          type: 'projects-realized',
          codeName: 'PIMIS-003',
          reportFormats: ['pdf', 'xlsx']
        },
        {
          title: this.$t('reports.projectsInRealizationReportTitle'),
          description: this.$t('reports.projectsInRealizationReportDescription'),
          type: 'projects-realization',
          codeName: 'PIMIS-004',
          reportFormats: ['pdf', 'xlsx']
        },
        {
          title: this.$t('reports.projectsAllReportTitle'),
          description: this.$t('reports.projectsAllReportDescription'),
          type: 'projects-all',
          codeName: 'PIMIS-005',
          reportFormats: ['xlsx']
        },
        {
          title: this.$t('reports.projectsBoardAccepted'),
          description: this.$t('reports.rojectsBoardAcceptedDescription'),
          type: 'projects-board-accepted',
          codeName: 'PIMIS-006',
          reportFormats: ['pdf', 'xlsx']
        },
        {
          title: this.$t('reports.projectsByPhase'),
          description: this.$t('reports.projectsByPhaseDescription'),
          type: 'projects-by-phase',
          codeName: 'PIMIS-007',
          reportFormats: ['xlsx']
        },
        {
          title: this.$t('reports.projectsByOrganization'),
          description: this.$t('reports.projectsByOrganizationDescription'),
          type: 'projects-by-organization',
          codeName: 'PIMIS-008',
          reportFormats: ['xlsx']
        },
        {
          title: this.$t('reports.importantProjects'),
          description: this.$t('reports.importantProjectsDescription'),
          type: 'important-projects',
          codeName: 'PIMIS-009',
          reportFormats: ['xlsx']
        }
      ],
      help: {
        root: Vue.$helpConfig.reporting
      }
    }
  },
  computed: {
    displayBoardReports () {
      return hasAdminClaim()
    }
  },
  methods: {
    downloadReport (reportType, format) {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.generateBoardReportsGet + '/' + reportType + '/?reportFormat=' + format, { responseType: 'blob' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, reportType + '.' + format)
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    excelAvailable (type) {
      const report = this.reports.find(x => x.type === type)
      // console.log(report)
      if (report) {
        return report.reportFormats.some(x => x === 'xlsx')
      }
      return false
    },
    pdfAvailable (type) {
      const report = this.reports.find(x => x.type === type)
      // console.log(report)
      if (report) {
        return report.reportFormats.some(x => x === 'pdf')
      }
      return false
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style>

.report-item {
   font-size: 14px;
   font-weight: bold;
 }
.report-desc {
  font-weight: normal !important;
}
 </style>
